import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/img/Right SideText.svg";

const NavBar = () => {
  return (
    <div className="container-fluid py-2">
      <img src={logo} alt="logo" className="App-logo" />
      <ul className="menuList all">
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/aboutus">About Us</Link>
        </li>
        <li>
          <Link to="/contactus">Contact Us</Link>
        </li>
      </ul>
    </div>
  );
};

export default NavBar;
